@for (row of skeletonRows(); track $index) {
	<tr class="skeleton-row">
		@for (cell of skeletonCells(); track $index) {
			<td class="skeleton-cell">
				<div class="loading-bar">
					<div class="loading-bar-fill"></div>
				</div>
			</td>
		}
	</tr>
}
